// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__BNYUS","load6":"Spinner_load6__wmuZ3","round":"Spinner_round__orJRJ"};